import { INITIAL_COMPANY_DATA, FORM_FIELD_PATHS } from '../constants.js';

export const createUpdateFormData = (setFormData) => (field, value) => {
    if (field?.includes('.')) {
        const [parent, child] = field.split('.');
        setFormData((prev) => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [child]: value,
            },
        }));
    } else {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    }
};

export const createUpdateMultipleFields = (setFormData) => (updates) => {
    setFormData((prev) => ({
        ...prev,
        ...updates,
    }));
};

export const createResetForm =
    (setFormData, initialData = {}) =>
    () => {
        setFormData({
            ...INITIAL_COMPANY_DATA,
            ...initialData,
        });
    };

export const getInitialFormData = (initialData = {}) => ({
    ...INITIAL_COMPANY_DATA,
    ...initialData,
});

// The backend rejects an empty Data Processing Region (engineLocations) with
// a plain { message } body rather than a field-level errors map.
export const getEngineLocationsErrorMessage = (error) => {
    const message = error?.response?.data?.message || '';
    return /engine location/i.test(message) ? message : null;
};

// "All Available" is held as an empty selection in the form, but the backend
// requires at least one engine location, so send every available one instead.
export const withAllEngineLocationsIfEmpty = (formData, availableLocations) => {
    const selected = formData?.[FORM_FIELD_PATHS.ENGINE_LOCATIONS];
    if (selected?.length || !availableLocations?.length) return formData;
    return {
        ...formData,
        [FORM_FIELD_PATHS.ENGINE_LOCATIONS]: availableLocations,
    };
};
